import React from 'react'
import queryString from 'qs'
import flowRight from 'lodash/flowRight'
import styled from 'styled-components'

import useQuery from 'shared/hooks/useQuery'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import { ConfirmationType } from 'shared/components/Notes/models/confirmation'
import Box from 'shared/components/Box'

import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import Avatar from 'pages/Parent/components/Avatar'

type Props = WrappedProps<ConfirmationType> & {
  description?: string
}

function ConfirmationDialog(props: Props) {
  const { formState, formHandlers, onClose, onContinue, isProcessing, description } = props
  const { fields, errors } = formState
  const { onElementChange, onChange } = formHandlers

  return (
    <ConfirmationDialogBodyContainer className="confirm-dialog-container">
      {description && (
        <Box className="description">{description}</Box>
      )}
    </ConfirmationDialogBodyContainer>
  )
}

const WrappedConfirmationDialog = flowRight(withDialog())(ConfirmationDialog)
const ConfirmationDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px 40px 0;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`

WrappedConfirmationDialog.defaultProps = {
  // continueIsDisabled(data: ConfirmationDialogForm) {
  //   return !data.confirm
  // },
}

export default WrappedConfirmationDialog
